
{
  "familyId": "SPR-WEET-D-T",
  "questions": [
    {
      "id": "SPR-WEET-D-T-001",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "categorize",
      "question": "De laatste letter is verstopt. Eindigt het woord op een 'd' of op een 't'? Gebruik de verleng-truc.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Eindigt op d", "Eindigt op t"],
        "items": [
          { "text": "gelui_", "correctCategory": 0 },
          { "text": "gou_", "correctCategory": 0 },
          { "text": "beschui_", "correctCategory": 1 },
          { "text": "zwaar_", "correctCategory": 0 },
          { "text": "rech_", "correctCategory": 1 },
          { "text": "beroem_", "correctCategory": 0 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D of T? Maak het woord langer!", "content": "Twijfel je? Maak het woord langer of verbuig het:\n\ngeluid → geluiden (d) ✓\ngoud → gouden (d) ✓\nbeschuit → beschuiten (t) ✓\nzwaard → zwaarden (d) ✓\nrecht → rechten (t) ✓\nberoemd → beroemde (d) ✓", "icon": "book" } }
      ],
      "conceptId": "d_t_eind_categorize_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Maak elk woord langer: geluid→geluiden (d), goud→gouden (d), beschuit→beschuiten (t), zwaard→zwaarden (d), recht→rechten (t), beroemd→beroemde (d). Als je de 'd' hoort bij het langere woord, eindigt het op 'd'.",
        "solutionSteps": [
          "Geluid → geluiden: je hoort 'd' → eindigt op d",
          "Goud → gouden: je hoort 'd' → eindigt op d",
          "Beschuit → beschuiten: je hoort 't' → eindigt op t",
          "Zwaard → zwaarden: je hoort 'd' → eindigt op d",
          "Recht → rechten: je hoort 't' → eindigt op t",
          "Beroemd → beroemde: je hoort 'd' → eindigt op d"
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-002",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "error_spotting",
      "question": "Zoek de d/t-fouten in deze tekst. Tik op het foute woord en typ de verbetering.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Het gebout aan de overkant is heel beroemd. Mijn oom heeft daar jarenlang gewoond. Hij was altijd beschaaft tegen iedereen.",
        "errors": [
          { "word": "gebout", "position": 1, "correction": "gebouw", "rule": "Gebouw → gebouwen: je hoort geen 'd' of 't'. Het woord eindigt op 'w'. Let op: 'gebouwd' (voltooid deelwoord) is iets anders!" },
          { "word": "beschaaft", "position": 16, "correction": "beschaafd", "rule": "Beschaafd → beschaafde: je hoort de 'd'. Dus eindigt het op 'd', niet op 't'." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D of T? Maak het woord langer!", "content": "Twijfel je of een woord op d of t eindigt? Maak het langer!\n\nbeschaafd → beschaafde (je hoort 'd') → schrijf 'd'\ngebouw → gebouwen (je hoort 'w') → schrijf 'w'\n\nLet op: 'beroemd' en 'gewoond' zijn correct in deze tekst!", "icon": "book" } }
      ],
      "conceptId": "d_t_eind_error_spotting_1",
      "variantIndex": 2,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Twee fouten: 'gebout' moet 'gebouw' zijn (gebouw→gebouwen, geen d of t) en 'beschaaft' moet 'beschaafd' zijn (beschaafd→beschaafde, je hoort de 'd'). 'Beroemd' en 'gewoond' zijn wél correct.",
        "solutionSteps": [
          "Gebout → gebouw (gebouwen: je hoort 'w', niet 'd' of 't')",
          "Beschaaft → beschaafd (beschaafde: je hoort 'd')",
          "'Beroemd' is correct: beroemde → je hoort 'd' ✓",
          "'Gewoond' is correct: gewoonde → je hoort 'd' ✓"
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-003",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "sentence_error_judge",
      "question": "Welke zin bevat een d/t-fout?",
      "options": [],
      "correctAnswer": 2,
      "data": {
        "sentences": [
          { "text": "Het geluid van de muziek was prachtig.", "hasError": false, "explanation": "Correct: geluid → geluiden, je hoort de 'd'." },
          { "text": "De beschuit lag op het aanrecht.", "hasError": false, "explanation": "Correct: beschuit → beschuiten, je hoort de 't'." },
          { "text": "Ze was erg vermoeit na de wedstrijd.", "hasError": true, "correction": "Ze was erg vermoeid na de wedstrijd.", "explanation": "Fout: vermoeid → vermoeide, je hoort de 'd'. Dus: vermoeid, niet vermoeit." },
          { "text": "Hij is beroemd in heel Nederland.", "hasError": false, "explanation": "Correct: beroemd → beroemde, je hoort de 'd'." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D of T? Verbuig het woord!", "content": "Vermoeid → vermoeide: je hoort de 'd'. Dus schrijf je 'vermoeid' met een d.\n\nTruc: maak het woord langer of verbuig het. Als je een 'd' hoort, schrijf je 'd'.", "icon": "book" } }
      ],
      "conceptId": "d_t_eind_sentence_judge",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "'Vermoeit' is fout. Verbuig het woord: vermoeid → vermoeide. Je hoort de 'd', dus schrijf je 'vermoeid' met een d. De andere woorden (geluid, beschuit, beroemd) zijn correct.",
        "solutionSteps": [
          "Controleer elk woord met d/t aan het einde",
          "Vermoeit → vermoeide: je hoort 'd' → moet 'vermoeid' zijn → FOUT",
          "Geluid → geluiden: je hoort 'd' → correct ✓",
          "Beschuit → beschuiten: je hoort 't' → correct ✓",
          "Beroemd → beroemde: je hoort 'd' → correct ✓"
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-004",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "error_spotting",
      "question": "Zoek de d/t-fouten in deze tekst. Tik op het foute woord en typ de verbetering.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De grote hond rende over het brede pat naar de tuin. Daar lag een glanzend zwaart in het gras. Het was een mooie ochtend.",
        "errors": [
          { "word": "pat", "position": 8, "correction": "pad", "rule": "Pad → paden: je hoort de 'd'. Dus: pad met een d." },
          { "word": "zwaart", "position": 14, "correction": "zwaard", "rule": "Zwaard → zwaarden: je hoort de 'd'. Dus: zwaard met een d." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D of T? Meervoud-truc", "content": "Maak het zelfstandig naamwoord meervoud:\n\npad → paden (je hoort 'd') → schrijf 'd'\nzwaard → zwaarden (je hoort 'd') → schrijf 'd'\n\nLet op: 'hond', 'brede' en 'mooie' zijn correct!", "icon": "book" } }
      ],
      "conceptId": "d_t_eind_error_spotting_znw",
      "variantIndex": 4,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Twee fouten: 'pat' moet 'pad' zijn (pad → paden, je hoort 'd') en 'zwaart' moet 'zwaard' zijn (zwaard → zwaarden, je hoort 'd'). 'Hond', 'brede' en 'mooie' zijn wél correct.",
        "solutionSteps": [
          "Pat → pad (paden: je hoort 'd')",
          "Zwaart → zwaard (zwaarden: je hoort 'd')",
          "'Hond' is correct: honden → je hoort 'd' ✓",
          "'Brede' is verbuigingsvorm van 'breed': breed → brede ✓"
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-005",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "categorize",
      "question": "De laatste letter is verstopt. Eindigt dit zelfstandig naamwoord op '-d' of op '-t'? Maak het meervoud om te horen.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Eindigt op -d", "Eindigt op -t"],
        "items": [
          { "text": "paar_", "correctCategory": 0 },
          { "text": "vluch_", "correctCategory": 1 },
          { "text": "hon_", "correctCategory": 0 },
          { "text": "gezich_", "correctCategory": 1 },
          { "text": "jeug_", "correctCategory": 0 },
          { "text": "nich_", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D of T? Meervoud-truc", "content": "Maak het zelfstandig naamwoord meervoud (of verlengd):\n\npaard → paarden (d) ✓\nvlucht → vluchten (t) ✓\nhond → honden (d) ✓\ngezicht → gezichten (t) ✓\njeugd → jeugdig (d) ✓\nnicht → nichten (t) ✓", "icon": "book" } }
      ],
      "conceptId": "d_t_eind_categorize_znw",
      "variantIndex": 5,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Maak elk woord langer: paard→paarden (d), vlucht→vluchten (t), hond→honden (d), gezicht→gezichten (t), jeugd→jeugdig (d), nicht→nichten (t).",
        "solutionSteps": [
          "Paard → paarden: je hoort 'd' → eindigt op d",
          "Vlucht → vluchten: je hoort 't' → eindigt op t",
          "Hond → honden: je hoort 'd' → eindigt op d",
          "Gezicht → gezichten: je hoort 't' → eindigt op t",
          "Jeugd → jeugdig: je hoort 'd' → eindigt op d",
          "Nicht → nichten: je hoort 't' → eindigt op t"
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-006",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "fill_in",
      "question": "Vul de juiste letter in: vermoe_ (moe na het sporten). Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["vermoeid"],
        "caseSensitive": false,
        "placeholder": "vermoe..."
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Meervoud-truc", "content": "Maak het woord langer: vermoeid → vermoeide. Je hoort de 'd', dus schrijf je 'vermoeid' met een d.", "icon": "book" } }
      ],
      "conceptId": "d_t_eind_fill_vermoeid",
      "variantIndex": 6,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Verbuig het woord: vermoeid → vermoeide. Je hoort de 'd', dus schrijf je 'vermoeid' met een d aan het einde.",
        "solutionSteps": [
          "Maak het woord langer: vermoeid → vermoeide",
          "Je hoort de 'd'-klank",
          "Dus: vermoeid (met d)"
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-007",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "fill_in",
      "question": "Vul de juiste letter in: beschaaf_ (netjes en beleefd). Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["beschaafd"],
        "caseSensitive": false,
        "placeholder": "beschaaf..."
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Verbuig het woord", "content": "Maak het woord langer: beschaafd → beschaafde. Je hoort de 'd', dus schrijf je 'beschaafd' met een d.", "icon": "book" } }
      ],
      "conceptId": "d_t_eind_fill_beschaafd",
      "variantIndex": 7,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Verbuig het woord: beschaafd → beschaafde. Je hoort de 'd', dus schrijf je 'beschaafd' met een d.",
        "solutionSteps": [
          "Maak het woord langer: beschaafd → beschaafde",
          "Je hoort de 'd'-klank",
          "Dus: beschaafd (met d)"
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-008",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "fill_in",
      "question": "Vul de juiste letter in: ongerus_ (bang en bezorgd). Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["ongerust"],
        "caseSensitive": false,
        "placeholder": "ongerus..."
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Verbuig het woord", "content": "Maak het woord langer: ongerust → ongeruste. Je hoort de 't', dus schrijf je 'ongerust' met een t.", "icon": "book" } }
      ],
      "conceptId": "d_t_eind_fill_ongerust",
      "variantIndex": 8,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Verbuig het woord: ongerust → ongeruste. Je hoort de 't', dus schrijf je 'ongerust' met een t.",
        "solutionSteps": [
          "Maak het woord langer: ongerust → ongeruste",
          "Je hoort de 't'-klank",
          "Dus: ongerust (met t)"
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-009",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "comparison_judge",
      "question": "Welke spelling is correct? Tik op het juiste woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "paard", "label": "met d" },
            { "id": "b", "content": "paart", "label": "met t" }
          ],
          "criterion": "Kies de juiste spelling",
          "correctIndex": 0
        }
      },
      "conceptId": "d_t_compare_paard",
      "variantIndex": 9,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D of T? Meervoud-truc", "content": "Maak het woord langer: paard → paarden. Je hoort de 'd', dus schrijf je 'paard' met een d. 'Paart' is een werkwoordsvorm (hij paart), niet het dier.", "icon": "book" } }
      ],
      "feedback": {
        "explanationText": "Meervoud-truc: paard → paarden. Je hoort duidelijk de 'd'. Dus schrijf je 'paard' met een d aan het einde. Let op: 'paart' bestaat wel, maar dat is een werkwoordsvorm (hij paart), niet het dier.",
        "solutionSteps": [
          "Maak het woord langer: paard → paarden",
          "Je hoort de 'd'-klank",
          "Dus: paard (met d) is correct"
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-010",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "comparison_judge",
      "question": "Welke spelling is correct? Tik op het juiste woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "geluid", "label": "met d" },
            { "id": "b", "content": "geluit", "label": "met t" }
          ],
          "criterion": "Kies de juiste spelling",
          "correctIndex": 0
        }
      },
      "conceptId": "d_t_compare_geluid",
      "variantIndex": 10,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D of T? Meervoud-truc", "content": "Maak het woord langer: geluid → geluiden. Je hoort de 'd', dus schrijf je 'geluid' met een d. 'Geluit' bestaat niet.", "icon": "book" } }
      ],
      "feedback": {
        "explanationText": "Meervoud-truc: geluid → geluiden. Je hoort duidelijk de 'd'. Dus schrijf je 'geluid' met een d aan het einde.",
        "solutionSteps": [
          "Maak het woord langer: geluid → geluiden",
          "Je hoort de 'd'-klank",
          "Dus: geluid (met d) is correct"
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-011",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t",
      "questionType": "spelling_pick",
      "question": "Eindigt het woord op d of t? Gebruik de verleng-truc.",
      "context": "Maak het woord langer (meervoud) en luister welke letter je hoort.",
      "data": {
        "spellingPick": {
          "variant": "d-t",
          "words": [
            { "before": "han", "after": "", "correct": "d", "hint": "hand → handen" },
            { "before": "kran", "after": "", "correct": "t", "hint": "krant → kranten" },
            { "before": "hon", "after": "", "correct": "d", "hint": "hond → honden" }
          ]
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D of T? Verleng-truc", "content": "Maak het woord langer: hand → handen (je hoort d), krant → kranten (je hoort t), hond → honden (je hoort d).", "icon": "book" } }
      ],
      "conceptId": "d_t_pick_verlengtruc_trio",
      "variantIndex": 11,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Verleng-truc: hand → handen (d), krant → kranten (t), hond → honden (d). Luister naar de klank in het meervoud.",
        "solutionSteps": [
          "hand → handen → d",
          "krant → kranten → t",
          "hond → honden → d"
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-012",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t",
      "questionType": "spelling_pick",
      "question": "D of t aan het eind? Verleng het woord.",
      "context": "Maak het woord langer en hoor de juiste letter.",
      "data": {
        "spellingPick": {
          "variant": "d-t",
          "words": [
            { "before": "woor", "after": "", "correct": "d", "hint": "woord → woorden" },
            { "before": "kas", "after": "", "correct": "t", "hint": "kast → kasten" }
          ]
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "D of T? Verleng-truc", "content": "woord → woorden (je hoort d), kast → kasten (je hoort t).", "icon": "book" } }
      ],
      "conceptId": "d_t_pick_verlengtruc_duo",
      "variantIndex": 12,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Verleng-truc: woord → woorden (d), kast → kasten (t).",
        "solutionSteps": [
          "woord → woorden → d",
          "kast → kasten → t"
        ]
      }
    }
  ]
}
